<div class="flex flex-1 justify-center">
	<div class="w-28">
		<img src="/assets/images/integrations/fct-logo.svg" />
	</div>
</div>
<div class="flex flex-1 justify-center">
	<div class="w-36">
		<img src="/assets/images/closer-logo.svg" />
	</div>
</div>
